import { Component, Output, EventEmitter, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = "en";
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  public isCollapsed = true;
  layoutSub: Subscription;
  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  public config: any = {};
  public userName: string = 'Admin';

  constructor(public translate: TranslateService, private layoutService: LayoutService, private configService:ConfigService,private router: Router) {

  }

  ngOnInit() {
    // Show the logged-in user's name (falls back to 'Admin' if not present)
    const storedName = localStorage.getItem('userName');
    if (storedName && storedName !== 'null' && storedName !== 'undefined') {
      this.userName = storedName;
    }
  }

  ngAfterViewInit() {
    
  }

  ngOnDestroy() {
    
  }

  logout(){
    // NOTE: deliberately does NOT revoke the "remember this device" grant - the whole
    // point of that feature is that logging out and back in within 30 days on the same
    // device should NOT require OTP again. Revoking it here would defeat that entirely.
    // (revokeDeviceTrust is still available on the backend for a future explicit "forget
    // this device" action, just not wired into ordinary logout.)
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('Role');
    this.router.navigate(["/pages/login"]);

  }

  
}
